import cashFlowHandler from '~/composable/checkout/handler/cashFlowHandler';
import { STEP_TYPE } from '~/constants/StepType';
import useCustomerInfo from '~/composable/checkout/useCustomerInfo';
import useConfirmationInfo from '~/composable/checkout/useConfirmationInfo';
import usePaymentInfo from '~/composable/checkout/usePaymentInfo';

export default function flowWithoutSubscription (appContext) {
  const panels = [
    {
      stepType: STEP_TYPE.CUSTOMER_INFO,
      heading: 'Kundeforhold',
      component: 'tlm-checkout-customer-info',
      componentDone: 'tlm-checkout-customer-type-done',
      contextName: 'customerInfo',
      hasNextButton: false
    },
    {
      stepType: STEP_TYPE.CUSTOMER_INFO_CONFIRMATION,
      heading: 'Kundeoplysninger og levering',
      component: 'tlm-checkout-customer-confirmation-type',
      componentDone: 'tlm-checkout-customer-info-done',
      hasNextButton: false
    },
    {
      stepType: STEP_TYPE.CONFIRMATION,
      heading: 'Opsummering',
      component: 'tlm-checkout-confirmation',
      componentDone: 'tlm-checkout-confirmation-done',
      validationComponent: 'tlm-checkout-step-validators-stock-validation',
      hasNextButton: false
    },
    {
      stepType: STEP_TYPE.PAYMENT,
      heading: 'Betaling',
      component: 'payment-container',
      hasNextButton: false
    }
  ]
  let flowHandler = null;
  flowHandler = cashFlowHandler();
  const { payment } = usePaymentInfo()
  const { confirmation } = useConfirmationInfo()
  return {
    confirmation,
    panels,
    customerInfo: useCustomerInfo(appContext),
    payment,
    flowHandler
  }
}
